import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'open-raptor-section-offramp-default',
  templateUrl: './raptor-section-offramp-default.component.html',
  styleUrls: ['./raptor-section-offramp-default.component.scss']
})
export class RaptorSectionOfframpDefaultComponent implements OnInit {
  @Input() section: any;
  @Input() form!: FormGroup;

  sectionClass: string = '';
  heroType: string = '';

  constructor() { }

  ngOnInit(): void {
    this.section.settings = this.section.settings || {};
    // apply layout settings for the section
    if (this.section.settings.card === true) {
      this.sectionClass += 'raptor-section-card ';
    }
    if (this.section.settings.banner) {
      this.sectionClass += 'has-banner ';
    }
    if (this.section.settings.hero) {
      this.heroType = this.section.settings.hero.split('.').pop().toLowerCase();
    }
  }

}
